import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleRipple } from '../../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  ImageSection,
  Image,
  ContentSection,
  Title,
  Text,
  Button,
  Orangecircle,
} from './styled';

const Play = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageSection>
          <Image
            src={formatMessage({ id: 'home.spendrewards.play.image.src' })}
            alt={formatMessage({ id: 'home.spendrewards.play.image.alt' })}
            loading="lazy"
          />
        </ImageSection>
        <ContentSection>
          <Title>
            <FormattedMessage id="home.spendrewards.play.title" />
          </Title>
          <Text>
            <FormattedMessage id="home.spendrewards.play.text" />
          </Text>
          <Button
            href={formatMessage({
              id: 'home.spendrewards.play.buttonLink',
            })}
            target="_blank"
            onMouseEnter={handleRipple}
          >
            <FormattedMessage id="home.spendrewards.play.buttonText" />
            <Orangecircle
              src="/images/uploads/orange-icon.svg"
              alt="Orange Icon"
            />
          </Button>
        </ContentSection>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const PlayFragment = graphql`
  fragment Play on Json {
    spendrewards {
      play {
        image {
          src
          alt
        }
        title
        text
        buttonText
        buttonLink
      }
    }
  }
`;

export default Play;
